// Error keys returned by the move endpoints (plain-text response body).
// F6 must provide a translation for each `campaigns.move.errors.<key>`.
export const MOVE_ERROR_KEYS = [
  'move_missing_params',
  'move_same_campaign',
  'move_too_many_candidates',
  'move_partner_campaign_not_allowed',
  'move_campaign_not_found',
  'move_forbidden',
  'move_different_company',
  'move_candidate_not_in_source',
  'move_candidate_playing',
  'move_candidate_already_in_destination',
  'move_candidate_ie_disabled_in_destination',
  'move_insufficient_credits',
  'move_ie_mismatch',
  'move_failed',
];

export const MOVE_ERRORS_I18N_PREFIX = 'campaigns.move.errors';
export const MOVE_GENERIC_ERROR_I18N_KEY = `${MOVE_ERRORS_I18N_PREFIX}.generic`;

// http.js throws the axios response, so the backend key is `error.data`.
export const getMoveErrorKey = (error) => {
  const body = error && error.data;
  if (typeof body !== 'string') return null;
  return body.trim() || null;
};

export const getMoveErrorI18nKey = (key) =>
  MOVE_ERROR_KEYS.includes(key)
    ? `${MOVE_ERRORS_I18N_PREFIX}.${key}`
    : MOVE_GENERIC_ERROR_I18N_KEY;
